import {createSearchParams, URLSearchParamsInit, useNavigate} from "react-router-dom";
import {AppSettings} from "../settings";

/**
 * Custom hook that provides a set of functions for navigating to the different The Cell Map pages.
 */
export const useTheCellMapNavigation = () => {
  const navigate = useNavigate();

  /**
   * Opens a new tab or just switches to the given path using Router
   */
  const navigateTo = (path: string, newTab = false) => {
    if (newTab) window.open(path, "_blank");
    else navigate(path);
    return path;
  }

  /**
   * Build URL path for the given route and query parameters. Makes sure to prefix the path with the local URL prefix.
   */
  const buildPath = (route: string, queryParams?: URLSearchParamsInit | undefined) => {
    return `${AppSettings.LOCAL_URL_PREFIX}/${route}${queryParams ? "?" + createSearchParams(queryParams).toString() : ""}`;
  }

  /**
   * Route to list page
   */
  const openList = (queryParams?: URLSearchParamsInit | undefined, newTab = false) => {
    return navigateTo(buildPath("list", queryParams), newTab);
  };

  /**
   * Route to overlay page
   */
  const openOverlay = (queryParams?: URLSearchParamsInit | undefined, newTab = false) => {
    return navigateTo(buildPath("overlay", queryParams), newTab);
  };

  /**
   * Route to subnetwork page
   */
  const openSubnetwork = (queryParams?: URLSearchParamsInit | undefined, newTab = false) => {
    return navigateTo(buildPath("subnetwork", queryParams), newTab);
  };

  return {openList, openOverlay, openSubnetwork};
};
